<template>
	<v-dialog
		v-model="show"
		scrollable
		max-width="100%"
		@input="close()"
		transition="dialog-transition">
		<v-card class="background">
			<v-card-title
				class="py-1 px-3 primary color--text subheading word-break-all">
				<v-btn flat icon color="color" class="my-0" @click="openFile()">
					<v-icon>folder</v-icon>
				</v-btn>
				{{ html_path }}
				<v-spacer></v-spacer>
				<v-btn flat icon color="color" class="my-0" @click="close()">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="pa-0" v-if="show" style="height: 80vh">
				<v-container grid-list-xs v-if="loading || error">
					<v-progress-linear
						v-if="loading"
						color="primary"
						indeterminate>
					</v-progress-linear>
					<v-alert type="error" class="pa-2 ma-0" :value="error !== null">
						{{ error }}
					</v-alert>
				</v-container>
				<div ref="html_viewer"
					class="p-2"
					width="100%"
					height="100%"></div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: {
		html_path: {
			type: String,
			required: false,
			default: ''
		}
	},
	data () {
		return {
			show: false,
			loading: false,
			language: null,
			error: null
		}
	},
	watch: {
		html_path (value) {
			this.error = null
			if (!value) {
				this.show = false
				return
			}
			this.loading = true
			this.show = true
			let that = this
			this.$ApiNexus.cat(value)
				.then(result => {
					this.loading = false
					let root = that.$refs.html_viewer
					root.innerHTML = this.$sanitize(result.data)

					// Replace img src relative paths with gravity API links
					Array.from($(root).find('img, source')).forEach(img => {
						let host = window.location.href.toString().split(window.location.host)[0] + window.location.host + '/'
						if (img.src.startsWith(host)) {
							let img_src = img.src.replace(host, '')
							img.src = this.$ApiNexus.download_url(value.substring(0, value.lastIndexOf('/') + 1) + img_src)
						}
					})
					// Fix anchor links
					Array.from(root.getElementsByTagName('a')).forEach(a => {
						let host = window.location.href.toString().split(window.location.host)[0] + window.location.host + '/'
						if (a.href.startsWith(host)) {
							let href = a.href.replace(host, '') // relative path
							a.removeAttribute('href')
							a.style.cursor = 'default'
							if (href.startsWith('#')) {			// anchor
								a.style.color = 'var(--v-primary-base)'
								a.style.cursor = 'pointer'
								a.onclick = function () {
									root.querySelector(href).scrollIntoView({ behavior: 'smooth' })
								}
							} else if (!href.includes('/')) {
								a.style.color = 'var(--v-primary-base)'
								a.style.cursor = 'pointer'
								a.href = that.$ApiNexus.download_url(value.substring(0, value.lastIndexOf('/') + 1) + href)
							}
						}
					})
				})
				.catch(error => {
					console.error('readFile error', error.response)
					this.loading = false
					this.error = error.response.data.error
				})
		}
	},
	methods: {
		openFile () {
			this.$FileOpener.fileOpener('show', this.html_path)
				.catch(error => {
					console.error('openWorkingDir error', error)
				})
		},
		close () {
			this.show = false
			this.error = null
			this.$emit('close')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/html_reader_modal.vue